import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const audienceItems = ['Vous vivez en appartement (balcon, terrasse ou simple fenêtre).', 'Vous en avez assez de payer le "Bio" à prix d\'or.', 'Vous voulez une nourriture 40x plus nutritive que celle du commerce.', "Vous n'avez que 10 minutes par jour à y consacrer."];
export function TargetAudience() {
  return <section className="bg-white py-24 px-6" data-id="element-132">
      <div className="max-w-[800px] mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-134">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-135">
            Pour qui est-ce fait ?
          </h2>
          <div className="h-1 w-16 bg-forest mx-auto rounded-full" data-id="element-136"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-137">
          {audienceItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 rounded-xl bg-cream/50 border border-cream-dark hover:bg-cream transition-colors duration-300" data-id="element-138">
              <CheckCircle2 className="w-6 h-6 text-forest flex-shrink-0 mt-0.5" data-id="element-139" />
              <p className="font-sans text-lg text-charcoal font-medium" data-id="element-140">
                {item}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}